module.exports = __webpack_public_path__ + "assets/explore-1eba9ecddbaa57b9367bb403453abb2e.svg";